var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "boligvelgeren" } },
    [
      _c("div", { attrs: { id: "scrollHelper" } }),
      _vm._v(" "),
      _vm.loadStatus === "loaded"
        ? _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_c("router-view")],
            1
          )
        : _vm.loadStatus === "empty" || _vm.loadStatus === "error"
        ? _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_c("error-message")],
            1
          )
        : _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_c("page-loader")],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }